import { getLockedTransactionDescription } from './copyConstants'
import { Alert } from '@/ui'

interface Props {
  year: string
  admin?: boolean
  userOnlyLocked?: boolean
}

export const LockedBooksMessage = ({
  year,
  admin,
  userOnlyLocked,
  ...rest
}: Props) => {
  const message = admin
    ? userOnlyLocked
      ? getLockedTransactionDescription(year).adminUserLockedBannerMessage
      : getLockedTransactionDescription(year).adminLockedBannerMessage
    : getLockedTransactionDescription().lockedBannerMessage
  return (
    <Alert variant="warning" {...rest}>
      {message}
    </Alert>
  )
}
